import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Composant carousel de logos avec navigation par pagination bullets.
 */
export default class LogoSlider extends Base {
  static config = {
    name: 'LogoSlider',
    refs: ['slider', 'pagination'],
  };

  /**
   * Initialise le Swiper avec pagination bullets et breakpoints responsives.
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 3,
      slidesPerGroup: 3,
      grabCursor: true,
      spaceBetween: 32,
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
        type: 'bullets',
      },
      breakpoints: {
        480: { slidesPerView: 4, slidesPerGroup: 4 },
        640: { slidesPerView: 5, slidesPerGroup: 5 },
        1280: { slidesPerView: 6, slidesPerGroup: 6 },
      },
    });
  }
}
